import axios from '../service/axios/axios'
export default {
  //名医堂分组是否公开
  changeIsOpenStatus(data) {
    return axios({
      method: 'post',
      url: 'platform/sdepartment/changeIsOpenStatus',
      data: data,
    })
  },
  /**** 医生义诊活动（患） ****/
  //  医生义诊活动列表（患）
  freeDoctorGroupList(data) {
    return axios({
      method: 'post',
      url: 'platform/Activity/freeDoctorGroupList',
      data: data,
    })
  },
  //  添加医生义诊活动
  addFreeDoctorGroup(data) {
    return axios({
      method: 'post',
      url: 'platform/Activity/addFreeDoctorGroup',
      data: data,
    })
  },
  //  删除医生义诊活动
  deleteFreeDoctorGroup(data) {
    return axios({
      method: 'post',
      url: 'platform/Activity/deleteFreeDoctorGroup',
      data: data,
    })
  },
  // 医生义诊活动详情（回显）
  freeDoctorGroupDetail(data) {
    return axios({
      method: 'post',
      url: 'platform/Activity/freeDoctorGroupDetail',
      data: data,
    })
  },
  // 编辑医生义诊活动
  updateFreeDoctorGroup(data) {
    return axios({
      method: 'post',
      url: 'platform/Activity/updateFreeDoctorGroup',
      data: data,
    })
  },
  // 医生义诊活动-医生维护
  freeDoctorList(data) {
    return axios({
      method: 'post',
      url: 'platform/Activity/freeDoctorList',
      data: data,
    })
  },
  // 修改医生维护来源
  editFreeDoctorGroupSource(data) {
    return axios({
      method: 'post',
      url: 'platform/Activity/editFreeDoctorGroupSource',
      data: data,
    })
  },
  // 删除自定义医生
  deleteFreeDoctor(data) {
    return axios({
      method: 'post',
      url: 'platform/Activity/deleteFreeDoctor',
      data: data,
    })
  },
  // 添加自定义医生
  addFreeDoctor(data) {
    return axios({
      method: 'post',
      url: 'platform/Activity/addFreeDoctor',
      data: data,
    })
  },
  // 义诊医生列表
  getFreeDoctor(data) {
    return axios({
      method: 'post',
      url: 'platform/Activity/getFreeDoctor',
      data: data,
    })
  },
  // 编辑医生标签
  editFreeLabel(data) {
    return axios({
      method: 'post',
      url: 'platform/Activity/editFreeLabel',
      data: data,
    })
  },
  // 获取标签分类
  getFreeLabelCategory(data) {
    return axios({
      method: 'post',
      url: 'platform/Activity/getFreeLabelCategory',
      data: data,
    })
  },
  // 获取标签
  getFreeLabel(data) {
    return axios({
      method: 'post',
      url: 'platform/Activity/getFreeLabel',
      data: data,
    })
  },
  /**** 医生分组 ****/
  // 获取医生维护医生列表
  getFamousDoctorList(data) {
    return axios({
      method: 'post',
      url: 'platform/sdepartment/getFamousDoctorList',
      data: data,
    })
  },
  // 修改医生维护来源
  editFamousDoctorGroupSource(data) {
    return axios({
      method: 'post',
      url: 'platform/sdepartment/editFamousDoctorGroupSource',
      data: data,
    })
  },
  // 编辑标签和分类
  editFamousLabel(data) {
    return axios({
      method: 'post',
      url: 'platform/sdepartment/editFamousLabel',
      data: data,
    })
  },
  /**** 智慧医疗 ****/
  // 获取激活记录列表
  getHouseListPaing(data) {
    return axios({
      method: 'post',
      url: 'platform/Property/getHouseListPaing',
      data: data,
    })
  },
  // 获取激活记录详情
  getActivateDetail(data) {
    return axios({
      method: 'post',
      url: 'platform/Property/getActivateDetail',
      data: data,
    })
  },
  // 修改激活记录
  modifyActiveLog(data) {
    return axios({
      method: 'post',
      url: 'platform/Property/modifyActiveLog',
      data: data,
    })
  },
  // 获取场所列表
  getPlaceList(data) {
    return axios({
      method: 'post',
      url: 'platform/Property/getPlaceList',
      data: data,
    })
  },
  // 删除激活记录
  deleteActiveLog(data) {
    return axios({
      method: 'post',
      url: 'platform/Property/deleteActiveLog',
      data: data,
    })
  },
  /**** 名医工作室列表配置 --- start ****/
  // 获取名医工作室配置
  getFamousDoctorList(data) {
    return axios({
      method: 'post',
      url: 'platform/Doctor/getFamousDoctorList',
      data: data,
    })
  },
  // 保存名医工作室配置
  saveFamousDoctorList(data) {
    return axios({
      method: 'post',
      url: 'platform/doctor/saveFamousDoctorList',
      data: data,
    })
  },
  // 获取列表维护标签
  getFamousDoctorListLabel(data) {
    return axios({
      method: 'post',
      url: 'platform/Doctor/getFamousDoctorListLabel',
      data: data,
    })
  },
  // 保存标签
  saveFamousDoctorListLabel(data) {
    return axios({
      method: 'post',
      url: 'platform/doctor/saveFamousDoctorListLabel',
      data: data,
    })
  },
  // 删除标签
  deleteFamousDoctorListLabel(data) {
    return axios({
      method: 'post',
      url: 'platform/doctor/deleteFamousDoctorListLabel',
      data: data,
    })
  },
  // 标签排序
  sortFamousDoctorListLabel(data) {
    return axios({
      method: 'post',
      url: 'platform/doctor/sortFamousDoctorListLabel',
      data: data,
    })
  },
  // 获取标签banner
  getFamousDoctorListLabelBanner(data) {
    return axios({
      method: 'post',
      url: 'platform/Doctor/getFamousDoctorListLabelBanner',
      data: data,
    })
  },
  // 添加标签banner
  addFamousDoctorListLabelBanner(data) {
    return axios({
      method: 'post',
      url: 'platform/doctor/addFamousDoctorListLabelBanner',
      data: data,
    })
  },
  // 编辑标签banner
  updateFamousDoctorListLabelBanner(data) {
    return axios({
      method: 'post',
      url: 'platform/doctor/updateFamousDoctorListLabelBanner',
      data: data,
    })
  },
  // 删除banner
  deleteFamousDoctorListLabelBanner(data) {
    return axios({
      method: 'post',
      url: 'platform/doctor/deleteFamousDoctorListLabelBanner',
      data: data,
    })
  },
  // banner排序
  sortFamousDoctorListLabelBanner(data) {
    return axios({
      method: 'post',
      url: 'platform/doctor/sortFamousDoctorListLabelBanner',
      data: data,
    })
  },
  /**** 名医工作室列表配置 --- end ****/
}
